import { getQueryParamValue, isSSR } from './wix-code-api';
export function simulateControllerError(controllerConfig) {
    const simulateError = getSimulateControllerError(controllerConfig);
    const ssr = isSSR(controllerConfig.wixCodeApi);
    if (simulateError) {
        throw new Error(`Simulated Error: Controller, ${ssr ? 'SSR' : 'CSR'}`);
    }
}
export function getSimulateWidgetError(controllerConfig) {
    return getSimulateError(controllerConfig, 'simulateWidgetError');
}
function getSimulateControllerError(controllerConfig) {
    return getSimulateError(controllerConfig, 'simulateControllerError');
}
function getSimulateError({ wixCodeApi }, queryParam) {
    const simulateError = getQueryParamValue(wixCodeApi, queryParam);
    const ssr = isSSR(wixCodeApi);
    return simulateError === 'csr' && !ssr || simulateError === 'ssr' && ssr;
}

//# sourceMappingURL=simulate-error.js.map